import { useEffect, useState } from "react";
import { apiFetch } from "../services/api.js";
import { exportarEmExcel } from "../services/exportData.js";
import TabelaCampanhas from "../components/TabelaCampanhas.js";
import TabelaSorteios from "../components/TabelaSorteios.js";
import { getUser } from "../services/auth.js";
import CreateUserForm from "../components/CreateUserForm.js";

export default function Admin() {
  const [campanhas, setCampanhas] = useState([]);
  const [anuais, setAnuais] = useState([]);
  const [loading, setLoading] = useState(true);
  const [exportando, setExportando] = useState(false);
  const [recarregarKey, setRecarregarKey] = useState(0);
  const [logs, setLogs] = useState([]);
  const [users, setUsers] = useState([]);
  const [showArchived, setShowArchived] = useState(false);
  const [showAllLogs, setShowAllLogs] = useState(false);
  const [clientes, setClientes] = useState([]);

  useEffect(() => {
    carregarDados();
  }, [recarregarKey]);

  async function carregarDados() {
    try {
      const [campanhasRes, anuaisRes, clientesRes] = await Promise.all([
        apiFetch("campanhas"),
        apiFetch("anuais"),
        apiFetch("clientes"),
      ]);
      setCampanhas(campanhasRes?.campanhas || []);
      setAnuais(anuaisRes?.anuais || []);
      setClientes(clientesRes?.clientes || []);
      console.log("[ADMIN] Dados carregados");
      // fetch audit logs if admin
      const user = getUser();
      if (user?.role === "admin") {
        try {
          const logsRes = await apiFetch("audit");
          setLogs(logsRes?.logs || []);
          try {
            const usersRes = await apiFetch("users");
            setUsers(usersRes?.users || []);
          } catch (ue) {
            console.warn("Nao foi possivel carregar users:", ue.message);
          }
        } catch (e) {
          console.warn("Não foi possível carregar logs:", e.message);
        }
      }
    } catch (err) {
      console.error("[ERRO ADMIN]", err);
    } finally {
      setLoading(false);
    }
  }

  function handleRefresh() {
    setRecarregarKey((prev) => prev + 1);
  }

  async function handleExport() {
    setExportando(true);
    try {
      await exportarEmExcel();
      alert("Dados exportados com sucesso!");
    } catch (err) {
      console.error("[ERRO EXPORT]", err);
      alert("Erro ao exportar dados: " + err.message);
    } finally {
      setExportando(false);
    }
  }

  if (loading)
    return (
      <div className="container">
        <p>Carregando...</p>
      </div>
    );

  return (
    <div>
      <div className="container">
        <h2>Gerenciamento</h2>
        <p style={{ color: "#666", marginBottom: "1.5rem" }}>
          Aqui voce pode gerenciar campanhas e sorteios anuais
        </p>

        <button
          onClick={handleExport}
          disabled={exportando}
          style={{
            padding: "0.5rem 1rem",
            marginBottom: "1.5rem",
            backgroundColor: "#4CAF50",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: exportando ? "not-allowed" : "pointer",
            opacity: exportando ? 0.6 : 1,
            fontSize: "1rem",
          }}
        >
          {exportando ? "Exportando..." : "📥 Exportar Dados"}
        </button>

        <div className="stats-box">
          <div className="stat">
            <div className="stat-value">{campanhas.length}</div>
            <div className="stat-label">Campanhas</div>
          </div>
          <div className="stat">
            <div className="stat-value">{anuais.length}</div>
            <div className="stat-label">Sorteios Anuais</div>
          </div>
        </div>
      </div>

      <div className="container">
        <h3>Tabelas de Gerenciamento</h3>

        <div style={{ marginBottom: "3rem" }}>
          <h4>Campanhas</h4>
          {/* show only non-archived campaigns in main table */}
          <TabelaCampanhas
            campanhas={campanhas.filter((c) => !c.arquivado)}
            onRefresh={handleRefresh}
          />
          {/* archived panel */}
          <div style={{ marginTop: 12 }}>
            <button
              onClick={() => setShowArchived((v) => !v)}
              style={{ padding: "0.4rem 0.6rem" }}
            >
              {showArchived ? "Ocultar Arquivados" : "Mostrar Arquivados"}
            </button>
            {showArchived && (
              <div
                style={{ marginTop: 8, border: "1px solid #ddd", padding: 8 }}
              >
                <h5>Campanhas Arquivadas</h5>
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Inicio</th>
                      <th>Fim</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {campanhas
                      .filter((c) => c.arquivado)
                      .map((c) => (
                        <tr key={c.id}>
                          <td>{c.nome}</td>
                          <td>{c.data_inicio}</td>
                          <td>{c.data_fim}</td>
                          <td>
                            <button
                              onClick={async () => {
                                if (!window.confirm("Restaurar campanha?"))
                                  return;
                                try {
                                  await apiFetch(`campanhas/${c.id}`, {
                                    method: "PUT",
                                    body: JSON.stringify({
                                      arquivado: false,
                                      ativo: true,
                                    }),
                                  });
                                  handleRefresh();
                                } catch (err) {
                                  alert("Erro: " + err.message);
                                }
                              }}
                            >
                              Restaurar
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        <div>
          <h4>Sorteios Anuais</h4>
          <TabelaSorteios anuais={anuais} onRefresh={handleRefresh} />
        </div>
      </div>
      {getUser()?.role === "admin" && (
        <div className="container" style={{ marginTop: "2rem" }}>
          <h4>Usuários</h4>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <CreateUserForm onCreated={() => handleRefresh()} />
          </div>
          <div
            style={{
              marginTop: 12,
              border: "1px solid #ddd",
              borderRadius: "4px",
              padding: "8px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <h5 style={{ margin: 0 }}>Logs de Cupons</h5>
              <div style={{ display: "flex", gap: "8px" }}>
                <button
                  onClick={() => setShowAllLogs((v) => !v)}
                  style={{ padding: "0.4rem 0.6rem", fontSize: "0.9rem" }}
                >
                  {showAllLogs ? "Ocultar Logs" : "Mostrar Logs"}
                </button>
                <button
                  onClick={async () => {
                    try {
                      const cupomLogs = logs.filter(
                        (l) => l.action === "create_cupom",
                      );
                      const csvContent = [
                        ["Data", "Hora", "Usuário", "Resumo"].join(","),
                        ...cupomLogs.map((l) => {
                          const date = new Date(l.created_at);
                          const dataStr = date.toLocaleDateString("pt-BR");
                          const horaStr = date.toLocaleTimeString("pt-BR");
                          let summary = l.details;
                          try {
                            const d = JSON.parse(l.details);
                            const cliente = clientes.find(
                              (c) => c.id === d.clienteId,
                            );
                            if (d.count && cliente) {
                              summary = `Adicionou ${d.count} cupons para ${cliente.nome} (${cliente.documento})`;
                            }
                          } catch (e) {}
                          return [dataStr, horaStr, l.username || "-", summary]
                            .map((v) => `"${v}"`)
                            .join(",");
                        }),
                      ].join("\n");
                      const blob = new Blob([csvContent], { type: "text/csv" });
                      const url = URL.createObjectURL(blob);
                      const a = document.createElement("a");
                      a.href = url;
                      a.download = `logs_cupons_${new Date().toISOString().slice(0, 10)}.csv`;
                      a.click();
                    } catch (e) {
                      alert("Erro ao exportar: " + e.message);
                    }
                  }}
                  style={{
                    padding: "0.4rem 0.6rem",
                    fontSize: "0.9rem",
                    backgroundColor: "#27ae60",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  📥 Exportar
                </button>
                <button
                  onClick={async () => {
                    if (
                      !window.confirm(
                        "Tem certeza que deseja limpar todos os logs?",
                      )
                    )
                      return;
                    try {
                      await apiFetch("audit/clear", { method: "DELETE" });
                      setLogs([]);
                      alert("Logs limpos com sucesso!");
                    } catch (e) {
                      alert("Erro ao limpar logs: " + e.message);
                    }
                  }}
                  style={{
                    padding: "0.4rem 0.6rem",
                    fontSize: "0.9rem",
                    backgroundColor: "#e74c3c",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  🗑️ Limpar
                </button>
              </div>
            </div>
            {showAllLogs && (
              <div
                style={{
                  maxHeight: "400px",
                  overflowY: "auto",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                }}
              >
                <table style={{ width: "100%", fontSize: "0.9rem" }}>
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <tr>
                      <th
                        style={{
                          padding: "0.5rem",
                          textAlign: "left",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        Data
                      </th>
                      <th
                        style={{
                          padding: "0.5rem",
                          textAlign: "left",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        Hora
                      </th>
                      <th
                        style={{
                          padding: "0.5rem",
                          textAlign: "left",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        Usuário
                      </th>
                      <th
                        style={{
                          padding: "0.5rem",
                          textAlign: "left",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        Resumo
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs
                      .filter((l) => l.action === "create_cupom")
                      .reverse()
                      .map((l) => {
                        const date = new Date(l.created_at);
                        const dataStr = date.toLocaleDateString("pt-BR");
                        const horaStr = date.toLocaleTimeString("pt-BR");
                        let summary = l.details;
                        try {
                          const d = JSON.parse(l.details);
                          const cliente = clientes.find(
                            (c) => c.id === d.clienteId,
                          );
                          if (d.count && cliente) {
                            summary = `Adicionou ${d.count} cupons para ${cliente.nome} (${cliente.documento})`;
                          }
                        } catch (e) {}
                        return (
                          <tr
                            key={l.id}
                            style={{ borderBottom: "1px solid #eee" }}
                          >
                            <td style={{ padding: "0.5rem" }}>{dataStr}</td>
                            <td style={{ padding: "0.5rem" }}>{horaStr}</td>
                            <td style={{ padding: "0.5rem" }}>
                              {l.username || "-"}
                            </td>
                            <td style={{ padding: "0.5rem" }}>{summary}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          <table style={{ marginTop: "1rem" }}>
            <thead>
              <tr>
                <th>Usuário</th>
                <th>Papel</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id}>
                  <td>{u.username}</td>
                  <td>{u.role}</td>
                  <td>
                    <button
                      onClick={async () => {
                        const newUsername = window.prompt(
                          "Novo usuário:",
                          u.username,
                        );
                        if (!newUsername) return;
                        const newPassword = window.prompt(
                          "Nova senha (deixe em branco para manter):",
                          "",
                        );
                        const newRole =
                          window.prompt("Papel (admin/user):", u.role) ||
                          u.role;
                        try {
                          await apiFetch(`users/${u.id}`, {
                            method: "PUT",
                            body: JSON.stringify({
                              username: newUsername,
                              password: newPassword || undefined,
                              role: newRole,
                            }),
                          });
                          handleRefresh();
                        } catch (err) {
                          alert("Erro: " + err.message);
                        }
                      }}
                    >
                      Editar
                    </button>
                    <button
                      onClick={async () => {
                        if (!window.confirm("Excluir usuário?")) return;
                        try {
                          await apiFetch(`users/${u.id}`, { method: "DELETE" });
                          handleRefresh();
                        } catch (err) {
                          alert("Erro: " + err.message);
                        }
                      }}
                      style={{ marginLeft: 8 }}
                    >
                      Excluir
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {logs.length > 0 && (
        <div className="container" style={{ marginTop: "2rem" }}>
          <h4>Logs de Ações</h4>
          <table>
            <thead>
              <tr>
                <th>Data</th>
                <th>Usuário</th>
                <th>Ação</th>
                <th>Detalhes</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id}>
                  <td>{new Date(l.created_at).toLocaleString()}</td>
                  <td>{l.username || "-"}</td>
                  <td>{l.action}</td>
                  <td
                    style={{
                      maxWidth: 400,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {l.details}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
